module.exports = __webpack_public_path__ + "static/media/aroma_poradenstvi.8d401c00.svg";